<template>
  <li
    :class="{ 'is-active': isActive, 'boss-new': hasUnread }"
    class="tabs-title"
    data-test=""
    @click="$emit('click')"
  >
    <router-link
      :to="link"
      class="boss-tabs-link"
    >
      <span
        :class="iconName"
        class="boss-icon"
      />{{ title }}
      <span
        v-if="tooltip"
        v-tooltip="{ content: tooltip}"
        class="pega-circle"
      >?
      </span>
    </router-link>
  </li>
</template>

<style scoped>
.pega-circle {
  font-size: .7em;
  margin-left: 5px;
}
</style>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    hasUnread: {
      type: Boolean,
      default: false
    },
    link: {
      type: Object,
      default: () => ({})
    },
    isActive: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName () {
      return 'boss-icon-' + this.name
    }
  }
}
</script>
